import React from "react";
import CompanyAliasesEditor from "./CompanyAliasesEditor";
import CompanySourcesPanel from "./CompanySourcesPanel";
import RecordEditor from "../editor/RecordEditor";

const CompanyEditor = ({
  formError,
  companyAliases,
  onAddCompanyAlias,
  onRemoveCompanyAlias,
  onCompanyAliasChange,
  companyEditableEntries,
  formState,
  onChange,
  onAddArrayItem,
  onRemoveArrayItem,
  onArrayItemChange,
  onAddObjectField,
  onRemoveObjectField,
  onObjectFieldChange,
  selectedArrayItemByKey,
  selectedObjectFieldByKey,
  onSelectArrayItem,
  onSelectObjectField,
  companySourceGroups,
  sourceInlineInputByDataset,
  sourceInlineErrorByDataset,
  onSourceInlineInputChange,
  onClearSourceInlineInput,
  onSubmitInlineSources,
  onRemoveSourceIds,
  isSaving,
  sourceWindowState,
  sourceDatasetOptions,
  onOpenSourceWindow,
}) => (
  <div className="space-y-4">

    {formError ? (
      <div className="rounded-2xl border border-rose-500/20 bg-rose-500/10 px-4 py-3 text-sm text-rose-100">
        {formError}
      </div>
    ) : null}

    <CompanyAliasesEditor
      companyAliases={companyAliases}
      onAddCompanyAlias={onAddCompanyAlias}
      onRemoveCompanyAlias={onRemoveCompanyAlias}
      onCompanyAliasChange={onCompanyAliasChange}
    />

    <CompanySourcesPanel
      companySourceGroups={companySourceGroups}
      onOpenSourceWindow={onOpenSourceWindow}
      sourceInlineInputByDataset={sourceInlineInputByDataset}
      sourceInlineErrorByDataset={sourceInlineErrorByDataset}
      onSourceInlineInputChange={onSourceInlineInputChange}
      onClearSourceInlineInput={onClearSourceInlineInput}
      onSubmitInlineSources={onSubmitInlineSources}
      onRemoveSourceIds={onRemoveSourceIds}
      isSaving={isSaving}
      sourceWindowState={sourceWindowState}
      sourceDatasetOptions={sourceDatasetOptions}
    />

    {companyEditableEntries.length ? (
      <RecordEditor
        editableEntries={companyEditableEntries}
        formState={formState}
        onChange={onChange}
        onAddArrayItem={onAddArrayItem}
        onRemoveArrayItem={onRemoveArrayItem}
        onArrayItemChange={onArrayItemChange}
        onAddObjectField={onAddObjectField}
        onRemoveObjectField={onRemoveObjectField}
        onObjectFieldChange={onObjectFieldChange}
        selectedArrayItemByKey={selectedArrayItemByKey}
        selectedObjectFieldByKey={selectedObjectFieldByKey}
        onSelectArrayItem={onSelectArrayItem}
        onSelectObjectField={onSelectObjectField}
        formError=""
      />
    ) : null}
  </div>
);

export default CompanyEditor;
